export const formatPrice = price => {
	const formattedPrice = Math.round(+price);
	return `${typeof formattedPrice === 'number' ? formattedPrice.toLocaleString(undefined, {minimumFractionDigits: 0}) : 0} ₽`;
};
